<template>
  <NavBar></NavBar>
  <router-view/>
</template>

<style>

div, p, a, h1, h2, h3, h4, h5, h6 {
  -webkit-user-select: none; /* Safari */
  -ms-user-select: none; /* IE 10 and IE 11 */
  user-select: none; /* Standard syntax */
}

button {
  font-family: PollerOne, serif;
}

button:hover {
  cursor: pointer;
}

body {
  background-color: var(--color-background);
  color: var(--color-text);
  font-family: 'CamptonMedium', serif;
  padding: 0;
  margin: 0;
  transition: inherit;
  overflow-y: scroll;
}

a {
  text-decoration: none;
  color: var(--color-text);
  transition: transform 0.6s ease-in-out;
}

a:hover {
  text-decoration: underline;
}

a.router-link-exact-active {
  color: var(--color-primary);
}

a, h1, h2, h3, h4, h5, h6 {
  font-family: PollerOne, sans-serif;
}

p, label {
  font-family: BilboRegular, serif;
}
</style>

<script setup lang="ts">
import NavBar from "@/components/NavBar.vue";
import { onMounted, onUnmounted } from 'vue'
import Lenis from '@studio-freight/lenis'

let lenis: Lenis;

onMounted(() => {
  lenis = new Lenis({
    duration: 0.5,
    easing: (t: number) => t * (2 - t),
  })

  const raf = (time: number) => {
    lenis?.raf(time)
    requestAnimationFrame(raf)
  }

  requestAnimationFrame(raf)
})

onUnmounted(() => {
  lenis?.destroy()
})
</script>